import { matterPaths } from '@/routing/paths'
import TableChatCard from './TableChatCard'

export default function TableMessageCards({ matterId, tableIds }: { matterId: string; tableIds: string[] }) {
  if (!tableIds.length) return null
  return (
    <div aria-label="Referenced tables">
      {tableIds.map((tableId) => (
        <TableChatCard key={tableId} href={matterPaths.table(matterId, tableId)} />
      ))}
    </div>
  )
}
